// extracted by mini-css-extract-plugin
module.exports = {"bgTitle":"bgTitle_278Av","lookLook":"lookLook_1F2Qt","wave":"wave_19077","trainTrain":"trainTrain_3MiTp","circle":"circle_3uR6k"};